import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { MyOrdersFiltersBaseComponent } from '../../my-orders-filters-base.component';
import { DatePipe } from '@angular/common';
import { OrderAnalyticsService } from '@order/tracking/analytics/order-analytics.service';
import { MyOrdersAnalyticsService } from '@app/my-orders/tracking/analytics/my-orders-analytics.service';
import { FormControl } from '@angular/forms';
import { DatePreset } from '@app/my-orders/pages/order-status/constants/date-preset.enum';
import { MatCalendar } from '@angular/material/datepicker';
import { Moment } from 'moment';

@Component({
  selector: 'app-my-orders-filters-options-mobile',
  templateUrl: './my-orders-filters-options-mobile.component.html',
  styleUrls: ['./my-orders-filters-options-mobile.component.scss'],
})
export class MyOrdersFiltersOptionsMobileComponent
  extends MyOrdersFiltersBaseComponent
  implements OnInit, AfterViewInit
{
  @Input() numberOfItemsSelected = 0;
  @ViewChild('calendar') calendar: MatCalendar<Moment>;

  pageTitle = {
    orderStatus: 'i18n.orderStatusPage.orderStatus',
    customers: 'i18n.common.customers',
    deliveryMethod: 'i18n.orderStatusPage.deliveryMethod',
    orderPlacedDate: 'i18n.orderStatusPage.orderPlacedDate',
    deliveryDate: 'i18n.orderStatusPage.deliveryDate',
    seller: 'i18n.orderStatusPage.seller',
  };

  // Make DatePreset enum available in the template
  DatePreset = DatePreset;

  constructor(
    private nav: IonNav,
    modalController: ModalController,
    translateService: TranslateService,
    platformService: PlatformService,
    datePipe: DatePipe,
    myOrdersAnalyticsService: MyOrdersAnalyticsService,
  ) {
    super(
      modalController,
      translateService,
      platformService,
      datePipe,
      myOrdersAnalyticsService,
    );
    this.isOptionsComponent = true;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    // Apply any pending calendar navigation that occurred before the view was initialized
    this.applyPendingNavigation();
  }

  async returnToFilters() {
    await this.nav.pop();
  }

  /**
   * Navigates the calendar to the month containing the given date
   * @param date The date to navigate to
   */
  protected override navigateCalendarToStartDate(date: Moment): void {
    if (this.calendar) {
      // Use the calendar's active date property to navigate to the date's month
      this.calendar.activeDate = date;
      this.calendar.updateTodaysDate(); // Force calendar to refresh
    }
  }
}
